/**
 * REUSABLE UTILITIES - Main Export
 * Import utilities in your components:
 *
 * import { formatDate, formatCurrency } from '@/utils';
 * import { isValidEmail, validatePassword } from '@/utils';
 * import { debounce, copyToClipboard } from '@/utils';
 * import { STATUS_COLORS, USER_ROLES } from '@/utils';
 */

// Import all utilities for default export
import * as formatters from './formatters';
import * as validators from './validators';
import * as helpers from './helpers';
import * as constants from './constants';

// Re-export all utilities
export * from './formatters';
export * from './validators';
export * from './helpers';
export * from './constants';

// Default export for convenience
const utilsExport = {
  ...formatters,
  ...validators,
  ...helpers,
  ...constants,
};

export default utilsExport;
